let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bXCfz")).then(() => parcelRequire('3XnEp'));